import React from "react";
import { useDispatch } from "react-redux";
import { emptyCart } from "../redux/features/cartState"; // adjust this path as needed
import { useNavigate } from "react-router-dom";

const CancelAllOrdersModal = ({ isOpen, onClose, operatorId }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleConfirm = () => {
    dispatch(emptyCart());
    onClose();
    navigate(`/author/${operatorId}`);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="bg-white dark:bg-neutral-800 p-6 rounded-lg shadow-lg w-full max-w-sm mx-auto text-center border border-border">
        <h2 className="text-lg font-bold text-redlight mb-2">
          Cancel All Orders?
        </h2>
        <p className="text-gray-700 dark:text-gray-300 mb-6 text-sm">
          This will remove all items from your cart. Are you sure?
        </p>
        <div className="flex justify-center gap-4 text-sm">
          <button
            onClick={handleConfirm}
            className="bg-redlight hover:bg-red-700 text-white px-4 py-2 rounded"
          >
            Yes, Cancel All
          </button>
          <button
            onClick={onClose}
            className="bg-gray-200 hover:bg-gray-300 dark:bg-gray-600 dark:hover:bg-gray-500 text-gray-800 dark:text-white px-4 py-2 rounded"
          >
            No, Keep Orders
          </button>
        </div>
      </div>
    </div>
  );
};

export default CancelAllOrdersModal;
